<template>
	<v-card dark>
		<v-card-title>
			{{theBranch.name}}
		</v-card-title>
		<v-divider></v-divider>
		<v-card-text class="pa-0" dense>
			<v-list two-line>
				<v-list-item class="my-0" dense>
					<v-list-item-icon>
						<v-icon color="indigo">mdi-account-tie</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{$t("pages.projectForm.contact")}}:</v-list-item-title>
						<v-list-item-subtitle>{{ theBranch.contact_man }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-list-item class="my-0" dense>
					<v-list-item-icon>
						<v-icon color="indigo">mdi-phone</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{$t("pages.orderTable.tel")}}:</v-list-item-title>
						<v-list-item-subtitle>
							<whatsapp-link v-if="theBranch.tel" :tel="theBranch.tel"/>
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-list-item class="my-0" dense>
					<v-list-item-icon>
						<v-icon color="indigo">mdi-mail</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{$t("attributes.email")}}:</v-list-item-title>
						<v-list-item-subtitle>{{ theBranch.email }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-card-text>
	</v-card>
</template>

<script>
	import WhatsappLink from "dev/view/measurements/WhatsappLink";

	export default {
		name: "branch-card",
		props: {branch: Object, branchId: Number},
		components: {WhatsappLink},
		data() {
			return {};
		},
		computed: {
			branches() {
				return this.$store.state.BranchModule.branches;
			},
			theBranch() {
				return this.branch || this.branches.find(b => b.id === this.branchId) || {};
			}
		},
		methods: {},
		watch: {},
		created() {
		},
		mounted() {
		},
		updated() {
		},
		destroyed() {
		}
	};
</script>

<style scoped>

</style>
